import { render, staticRenderFns } from "./PriceSummary.vue?vue&type=template&id=63c99088"
import script from "./PriceSummary.vue?vue&type=script&lang=ts"
export * from "./PriceSummary.vue?vue&type=script&lang=ts"
import style0 from "./PriceSummary.vue?vue&type=style&index=0&id=63c99088&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports